import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M31.706 21H.28a35 35 0 0 1-.277-5.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107A35 35 0 0 1 31.706 21",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M14.978 6.686 16 3l1.022 3.686L19.6 3.81l-.723 3.667 3.505-1.512-2.297 3.094L24 9.2 20.544 11 24 12.8l-3.916.141 2.297 3.094-3.505-1.512.723 3.667-2.577-2.876L16 19l-1.022-3.685L12.4 18.19l.723-3.667-3.505 1.512 2.297-3.094L8 12.8l3.456-1.8L8 9.2l3.915-.141L9.62 5.965l3.505 1.512L12.4 3.81z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.178 12h31.66c.133 1.384.175 2.738.159 4.016.032 2.456-.193 5.233-.834 7.984H.836c-.672-2.75-.865-5.529-.833-8.017A35 35 0 0 1 .178 12",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M0 18v14h32V18z", clipRule: "evenodd" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M2.3 4.6 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .332-1.587 1.434-3.274",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M29.705 4.591c1.124 1.704 1.462 3.318 1.462 3.318.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagAtg = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagAtg_default = SvgFlagAtg;

export { FlagAtg_default as default };
